module.exports = __webpack_public_path__ + "img/star-logo.093b3c1d.png";